var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkedingCircleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 26,
    viewBox: "0 0 71 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6839 17.4392L28.8412 14.2394V17.4392H27.6379V7.65462H28.8412V13.4064L31.631 10.1933H33.3102L29.8989 13.803L33.3234 17.4392H31.6839Z",
    fill: "url(#paint0_linear_24282_139195)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0537 13.5386C41.0537 13.7678 41.0405 14.0102 41.0141 14.2658H35.2228C35.2669 14.9798 35.5093 15.5396 35.95 15.9451C36.3995 16.3417 36.9416 16.5401 37.5763 16.5401C38.0964 16.5401 38.5283 16.4211 38.8721 16.1831C39.2247 15.9363 39.4715 15.6101 39.6125 15.2046H40.9083C40.7144 15.901 40.3265 16.4696 39.7447 16.9103C39.163 17.3422 38.4402 17.5582 37.5763 17.5582C36.8888 17.5582 36.2717 17.4039 35.7252 17.0954C35.1875 16.7869 34.7644 16.3506 34.4559 15.7864C34.1474 15.2134 33.9931 14.5523 33.9931 13.803C33.9931 13.0538 34.143 12.3971 34.4427 11.8329C34.7424 11.2687 35.1611 10.8368 35.6988 10.5371C36.2453 10.2286 36.8711 10.0743 37.5763 10.0743C38.2639 10.0743 38.8721 10.2242 39.401 10.5239C39.9298 10.8236 40.3353 11.2379 40.6174 11.7668C40.9083 12.2869 41.0537 12.8775 41.0537 13.5386ZM39.8108 13.2874C39.8108 12.829 39.7095 12.4367 39.5067 12.1106C39.304 11.7756 39.0263 11.5244 38.6737 11.3569C38.33 11.1806 37.9465 11.0924 37.5234 11.0924C36.9152 11.0924 36.3951 11.2864 35.9632 11.6742C35.5401 12.0621 35.2977 12.5998 35.236 13.2874H39.8108Z",
    fill: "url(#paint1_linear_24282_139195)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1924 13.7898C42.1924 13.0494 42.3422 12.4015 42.6419 11.8461C42.9416 11.282 43.3515 10.8456 43.8716 10.5371C44.4005 10.2286 44.9911 10.0743 45.6433 10.0743C46.2075 10.0743 46.732 10.2065 47.2168 10.471C47.7016 10.7266 48.0718 11.066 48.3274 11.4891V7.65462H49.5439V17.4392H48.3274V16.0773C48.0894 16.5092 47.7368 16.8662 47.2697 17.1483C46.8025 17.4216 46.256 17.5582 45.6301 17.5582C44.9866 17.5582 44.4005 17.3995 43.8716 17.0822C43.3515 16.7649 42.9416 16.3197 42.6419 15.7467C42.3422 15.1738 42.1924 14.5215 42.1924 13.7898ZM48.3274 13.803C48.3274 13.2565 48.2172 12.7805 47.9969 12.375C47.7765 11.9695 47.4768 11.661 47.0978 11.4495C46.7276 11.2291 46.3177 11.1189 45.8681 11.1189C45.4186 11.1189 45.0087 11.2247 44.6385 11.4362C44.2682 11.6478 43.9729 11.9563 43.7526 12.3618C43.5322 12.7673 43.422 13.2433 43.422 13.7898C43.422 14.3452 43.5322 14.83 43.7526 15.2443C43.9729 15.6498 44.2682 15.9627 44.6385 16.1831C45.0087 16.3946 45.4186 16.5004 45.8681 16.5004C46.3177 16.5004 46.7276 16.3946 47.0978 16.1831C47.4768 15.9627 47.7765 15.6498 47.9969 15.2443C48.2172 14.83 48.3274 14.3496 48.3274 13.803Z",
    fill: "url(#paint2_linear_24282_139195)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1986 9.01653C51.9694 9.01653 51.7755 8.9372 51.6168 8.77853C51.4582 8.61986 51.3788 8.42593 51.3788 8.19674C51.3788 7.96755 51.4582 7.77363 51.6168 7.61496C51.7755 7.45629 51.9694 7.37695 52.1986 7.37695C52.419 7.37695 52.6041 7.45629 52.7539 7.61496C52.9126 7.77363 52.9919 7.96755 52.9919 8.19674C52.9919 8.42593 52.9126 8.61986 52.7539 8.77853C52.6041 8.9372 52.419 9.01653 52.1986 9.01653ZM52.7804 10.1933V17.4392H51.5772V10.1933H52.7804Z",
    fill: "url(#paint3_linear_24282_139195)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3613 10.0611C59.2428 10.0611 59.9568 10.33 60.5033 10.8677C61.0498 11.3966 61.3231 12.1635 61.3231 13.1684V17.4392H60.1331V13.3403C60.1331 12.6174 59.9524 12.0665 59.591 11.6875C59.2296 11.2996 58.736 11.1057 58.1101 11.1057C57.4755 11.1057 56.9686 11.304 56.5896 11.7007C56.2194 12.0974 56.0343 12.6747 56.0343 13.4328V17.4392H54.831V10.1933H56.0343V11.2247C56.2723 10.8544 56.594 10.568 56.9995 10.3652C57.4138 10.1625 57.8677 10.0611 58.3613 10.0611Z",
    fill: "url(#paint4_linear_24282_139195)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2767 10.0743C66.9026 10.0743 67.4491 10.211 67.9163 10.4842C68.3923 10.7575 68.7449 11.1013 68.974 11.5156V10.1933H70.1905V17.5979C70.1905 18.259 70.0494 18.8452 69.7674 19.3565C69.4853 19.8765 69.0798 20.282 68.5509 20.5729C68.0309 20.8638 67.4227 21.0093 66.7263 21.0093C65.7743 21.0093 64.981 20.7845 64.3463 20.3349C63.7117 19.8853 63.337 19.2727 63.2224 18.497H64.4124C64.5446 18.9377 64.8179 19.2903 65.2322 19.5548C65.6465 19.8281 66.1445 19.9647 66.7263 19.9647C67.3874 19.9647 67.9251 19.7575 68.3394 19.3432C68.7625 18.9289 68.974 18.3471 68.974 17.5979V16.0773C68.736 16.5004 68.3835 16.853 67.9163 17.1351C67.4491 17.4172 66.9026 17.5582 66.2767 17.5582C65.6333 17.5582 65.0471 17.3995 64.5182 17.0822C63.9981 16.7649 63.5882 16.3197 63.2885 15.7467C62.9888 15.1738 62.839 14.5215 62.839 13.7898C62.839 13.0494 62.9888 12.4015 63.2885 11.8461C63.5882 11.282 63.9981 10.8456 64.5182 10.5371C65.0471 10.2286 65.6333 10.0743 66.2767 10.0743ZM68.974 13.803C68.974 13.2565 68.8639 12.7805 68.6435 12.375C68.4231 11.9695 68.1234 11.661 67.7444 11.4495C67.3742 11.2291 66.9643 11.1189 66.5147 11.1189C66.0652 11.1189 65.6553 11.2247 65.2851 11.4362C64.9149 11.6478 64.6196 11.9563 64.3992 12.3618C64.1788 12.7673 64.0686 13.2433 64.0686 13.7898C64.0686 14.3452 64.1788 14.83 64.3992 15.2443C64.6196 15.6498 64.9149 15.9627 65.2851 16.1831C65.6553 16.3946 66.0652 16.5004 66.5147 16.5004C66.9643 16.5004 67.3742 16.3946 67.7444 16.1831C68.1234 15.9627 68.4231 15.6498 68.6435 15.2443C68.8639 14.83 68.974 14.3496 68.974 13.803Z",
    fill: "url(#paint5_linear_24282_139195)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9637,
    cy: 12.6622,
    rx: 12.326,
    ry: 12.3263,
    fill: "url(#paint6_linear_24282_139195)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.443 3.0098C19.4757 2.98189 19.4977 2.94308 19.5051 2.90021C19.5125 2.85735 19.5048 2.81319 19.4835 2.77555C19.4621 2.7379 19.4283 2.70918 19.3882 2.69446C19.3481 2.67975 19.3042 2.67998 19.2643 2.69512L9.40287 6.56508C8.54106 6.90681 7.84659 7.58283 7.47102 8.44561C7.09545 9.30839 7.06927 10.2879 7.39821 11.1703L7.42882 11.251C7.54436 11.5294 8.04503 12.4502 9.64185 12.5813L16.1467 13.1159C16.2403 13.1236 16.3296 13.1598 16.4029 13.2198C16.4763 13.2798 16.5304 13.3608 16.5583 13.4524C16.5863 13.544 16.5867 13.6421 16.5596 13.734C16.5326 13.8259 16.4792 13.9074 16.4064 13.9681L6.39785 22.3142C6.36515 22.3421 6.34315 22.3809 6.33575 22.4238C6.32835 22.4666 6.33602 22.5108 6.3574 22.5484C6.37879 22.5861 6.41251 22.6148 6.45261 22.6295C6.49272 22.6442 6.53663 22.644 6.57658 22.6289L16.437 18.7589C17.299 18.4174 17.9937 17.7414 18.3695 16.8786C18.7452 16.0158 18.7715 15.0362 18.4426 14.1537L18.4012 14.0448C18.2669 13.7422 17.7553 12.8869 16.2444 12.7457L9.6942 12.2081C9.60054 12.2004 9.5113 12.1642 9.43794 12.1042C9.36458 12.0442 9.31045 11.9632 9.28253 11.8716C9.2546 11.78 9.25415 11.6819 9.28123 11.59C9.3083 11.4981 9.36168 11.4166 9.43448 11.3559L19.443 3.0098Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24282_139195",
    x1: 27.6379,
    y1: 14.1931,
    x2: 70.1905,
    y2: 14.1931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24282_139195",
    x1: 0.637695,
    y1: 12.6622,
    x2: 25.2896,
    y2: 12.6622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkedingCircleLogo);
export default __webpack_public_path__ + "static/media/skeding-circle-logo.3fd083d965f0e061799d174b6a047aac.svg";
export { ForwardRef as ReactComponent };